<div *ngIf="loadingTerm">
    <span class="app-loading">
        <svg class="spinner" viewBox="25 25 50 50">
            <circle
                class="path"
                cx="50"
                cy="50"
                fill="none"
                r="20"
                stroke-miterlimit="10"
                stroke-width="2"
            />
        </svg>
    </span>
</div>
<form
    #termForm="ngForm"
    (ngSubmit)="onSubmit()"
    *ngIf="!loadingTerm"
    class="page-form"
>
    <div>
        <div class="lined-input-group">
            <label for="termName"> Name </label>
            <input
                #termName="ngModel"
                [(ngModel)]="term.name"
                [readOnly]="disableForNonAdmin"
                class="form-control"
                id="termName"
                name="termName"
                required
                type="text"
            />
            <div
                *ngIf="termName.invalid && (termName.dirty || termName.touched)"
                class="alert alert-danger"
            >
                <div *ngIf="termName.errors.required">
                    Term Name is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="startDateInput"> Start Date </label>
            <input
                #startDatePicker="bsDatepicker"
                #termStartDate="ngModel"
                [(ngModel)]="term.startDate"
                [disabled]="disableForNonAdmin"
                bsDatepicker
                class="form-control"
                id="startDateInput"
                name="termStartDate"
                required
                type="text"
            />
            <div
                *ngIf="
                    termStartDate.invalid &&
                    (termStartDate.dirty || termStartDate.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="termStartDate.errors.required">
                    Term Start Date is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="endDateInput"> End Date </label>
            <input
                #endDatePicker="bsDatepicker"
                #termEndDate="ngModel"
                [(ngModel)]="term.endDate"
                [disabled]="disableForNonAdmin"
                bsDatepicker
                class="form-control"
                id="endDateInput"
                name="termEndDate"
                required
                type="text"
            />
            <div
                *ngIf="
                    termEndDate.invalid &&
                    (termEndDate.dirty || termEndDate.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="termEndDate.errors.required">
                    Term End Date is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="startingBalance"> Starting Balance </label>
            <input
                #startingBalance="ngModel"
                [(ngModel)]="term.startingBalance"
                [min]="0.01"
                [readOnly]="disableForNonAdmin"
                [step]="0.01"
                class="form-control"
                id="startingBalance"
                name="startingBalance"
                required
                type="number"
            />
            <div
                *ngIf="
                    startingBalance.invalid &&
                    (startingBalance.dirty || startingBalance.touched)
                "
                class="alert alert-danger"
            >
                <div *ngIf="startingBalance.errors.required">
                    Starting Balance is required.
                </div>
            </div>
        </div>

        <div class="lined-input-group">
            <label> Term open for applications </label>
            <br/>
            <mat-slide-toggle
                *ngIf="!loadingTerm"
                [(ngModel)]="term.isOpen"
                [disabled]="disableForNonAdmin"
                class="slide-toggle"
                hideIcon="true"
                name="isOpen"
            >
                {{ term.isOpen ? "Open" : "Closed" }}
            </mat-slide-toggle>
        </div>

        <div *ngIf="showAllocationBar" class="allocation-bar">
            <eil-color-bar
                [ceiling]="term.startingBalance"
                [pending]="term.totalPending"
                [requested]="term.totalProposed"
                [showCeilingLabel]="true"
                [showLegend]="true"
                [showRemaining]="true"
                [spent]="term.totalSpent"
            >
            </eil-color-bar>
        </div>

        <div class="submit-button-div">
            <div *ngIf="savingTerm">
                <span class="app-loading">
                    <svg class="spinner" viewBox="25 25 50 50">
                        <circle
                            class="path"
                            cx="50"
                            cy="50"
                            fill="none"
                            r="20"
                            stroke-miterlimit="10"
                            stroke-width="2"
                        />
                    </svg>
                </span>
            </div>
            <button
                [disabled]="
                    !termForm.form.valid || savingTerm || disableForNonAdmin
                "
                class="btn btn-primary"
                type="submit"
            >
                Save Term
            </button>
            <div
                *ngIf="termForm.invalid && !loadingTerm"
                class="alert alert-danger"
            >
                <div *ngIf="termName.invalid && termName.errors.required">
                    Term Name is required.
                </div>
                <div
                    *ngIf="
                        termStartDate.invalid && termStartDate.errors.required
                    "
                >
                    Term Start Date is required.
                </div>
                <div *ngIf="termEndDate.invalid && termEndDate.errors.required">
                    Term End Date is required.
                </div>
                <div
                    *ngIf="
                        startingBalance.invalid &&
                        startingBalance.errors.required
                    "
                >
                    Term Starting Balance is required.
                </div>
            </div>
        </div>
    </div>
</form>
